import { EmptyContainer } from '@innovationnorway/component-library';
import { FC } from 'react';
import { useCustomerTaskClickHandler, useLocalizer } from '../../hooks';
import { CustomerTaskDto, CustomerTaskTypeEnum } from '../../models/digibank-mypage.models';
import { CustomerTaskApplicationCard } from '../CustomerTaskCard/CustomerTaskApplicationCard';
import { CustomerTaskConferenceGrantCard } from '../CustomerTaskCard/CustomerTaskConferenceGrantCard';
import { CustomerTaskFormCard } from '../CustomerTaskCard/CustomerTaskFormCard';
import { CustomerTaskInflowCard } from '../CustomerTaskCard/CustomerTaskInflowCard';
import { CustomerTaskListItemProps } from '../CustomerTaskCard/CustomerTaskListItemProps';
import { Accordion, AccordionContainer } from '../Shared/Accordion/Accordion';
import { LoadingSpinner } from '../Shared/LoadingSpinner/LoadingSpinner';
import { Paragraph } from '@innovationnorway/cl-react';

interface CustomerTaskListProps {
  tasks: Array<CustomerTaskDto>;
  isLoaded: boolean;
}

export const CustomerTaskList: FC<CustomerTaskListProps> = (props: CustomerTaskListProps) => {
  const { l } = useLocalizer('CustomerTasksList');
  const taskClickHandler = useCustomerTaskClickHandler();

  const activeTasks = props.tasks.filter((t) => t.active);
  const inActiveTasks = props.tasks.filter((t) => !t.active);

  if (!props.isLoaded) return <LoadingSpinner />;

  return (
    <div className="w-full">
      <div className="my-2">
        <Paragraph data-size="sm">{l('draftDeletionMessage')}</Paragraph>
      </div>
      {activeTasks.length ? (
        <ol className="pl-0 list-none">
          {props.tasks
            .filter((t) => t.active)
            .map((task) => (
              <CustomerTaskListItem key={task.id} task={task} onClick={() => taskClickHandler(task)} />
            ))}
        </ol>
      ) : (
        <EmptyContainer>{l('noTasksLabel')}</EmptyContainer>
      )}
      {inActiveTasks.length ? (
        <AccordionContainer>
          <Accordion title={l('historyLabel')} active>
            <ol className="pl-0 list-none">
              {props.tasks
                .filter((t) => !t.active)
                .map((task) => (
                  <CustomerTaskListItem key={task.id} task={task} onClick={() => taskClickHandler(task)} />
                ))}
            </ol>
          </Accordion>
        </AccordionContainer>
      ) : undefined}
    </div>
  );
};
const CustomerTaskListItem: FC<CustomerTaskListItemProps> = (props: CustomerTaskListItemProps) => {

  const renderCard = () => {
    switch (props.task.type) {
      case CustomerTaskTypeEnum.Application:
        return <CustomerTaskApplicationCard {...props} />;
      case CustomerTaskTypeEnum.Forms:
        return <CustomerTaskFormCard {...props} />;
      case CustomerTaskTypeEnum.Inflow:
        return <CustomerTaskInflowCard {...props} />;
      case CustomerTaskTypeEnum.ConferenceGrant:
        // If it is a conference grant in draft form, it shall be displayed as an application
        return <CustomerTaskConferenceGrantCard {...props} />;
      default:
        console.warn('Unknown task type: ', props.task.type);
        return <CustomerTaskInflowCard {...props} />; //Fallback
    }
  };

  return (
    <li>
      <button
        className={`mb-5 w-full block text-left bg-transparent border-2 border-white font-inherit p-0 text-inherit focus:outline-auto focus:border-2 focus:border-blue-400 hover:cursor-pointer ${props.disabled ? 'pointer-events-none opacity-50' : ''}`}
        style={{ textDecoration: 'none' }}
        onClick={() => {
          props.onClick();
        }}
      >
        {renderCard()}
      </button>
    </li>
  )
};
